class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      //console.log(url)

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
   //console.log('renderSectionFromFetch')
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
   //console.log('renderSectionFromCache')
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
   //console.log('renderProductGridContainer')
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
   //console.log('renderProductCount')
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static hideUnavailableFilters() {
    return Boolean(document.querySelector('.facets-container[data-hide-unavailable-filters]'));
  }

  static syncFilterOpenState(currentFilter, incomingFilter) {
    if (!FacetFiltersForm.hideUnavailableFilters()) return;
    if (!currentFilter || currentFilter.tagName !== 'DETAILS') return;
    // Only list filters can empty out; skip sort, price, availability, etc.
    if (!incomingFilter?.querySelector('.facets-drawer__list')) return;

    const hasAvailableValues = incomingFilter.querySelector(
      '.facets-drawer__list input:not(:disabled):not(.disabled)'
    );

    if (!hasAvailableValues) {
      currentFilter.classList.remove('active');
      currentFilter.removeAttribute('open');
    }
  }

  static renderFilters(html, event) {
   //console.log('renderFilters')
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormDrawer .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    // Update all non-active filters as before
    facetsToRender.forEach((element) => {
      const currentFilter = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (!currentFilter) return;

      const elementContent = element.querySelector('summary + *, .facets-drawer__single').innerHTML
      const currentContent = currentFilter.querySelector('summary + *, .facets-drawer__single');
      if (currentContent) currentContent.innerHTML = elementContent;

      FacetFiltersForm.syncFilterOpenState(currentFilter, element);
    });

    // For the active filter, sync values and counts without replacing the open group
    if (countsToRender && event && event.target.closest('.js-filter')) {
      const activeFilter = event.target.closest('.js-filter');

      if (FacetFiltersForm.hideUnavailableFilters()) {
        const currentList = activeFilter.querySelector('.facets-drawer__list');
        const newList = countsToRender.querySelector('.facets-drawer__list');

        if (currentList && newList) {
          currentList.querySelectorAll('li').forEach((item) => {
            const input = item.querySelector('input');
            if (!input || !newList.querySelector(`input[id="${input.id}"]`)) {
              item.remove();
            }
          });

          newList.querySelectorAll('li').forEach((newItem) => {
            const newInput = newItem.querySelector('input');
            if (!newInput) return;

            const currentItem = currentList.querySelector(`input[id="${newInput.id}"]`)?.closest('li');
            if (currentItem) {
              const currentLabel = currentItem.querySelector('label');
              const newLabel = newItem.querySelector('label');
              if (currentLabel && newLabel) currentLabel.innerHTML = newLabel.innerHTML;
              const currentInput = currentItem.querySelector('input');
              if (currentInput) currentInput.checked = newInput.checked;
            } else {
              currentList.appendChild(newItem.cloneNode(true));
            }
          });
        }

        FacetFiltersForm.syncFilterOpenState(activeFilter, countsToRender);
      } else {
        const newLabels = countsToRender.querySelectorAll('label[for^="Filter-"]');
        newLabels.forEach((newLabel) => {
          const forAttr = newLabel.getAttribute('for');
          const currentLabel = activeFilter.querySelector(`label[for="${forAttr}"]`);
          if (currentLabel) currentLabel.innerHTML = newLabel.innerHTML;

          const newInput = countsToRender.querySelector(`input[id="${forAttr}"]`);
          const currentInput = activeFilter.querySelector(`input[id="${forAttr}"]`);
          if (newInput && currentInput) {
            currentInput.disabled = newInput.disabled;
            currentInput.checked = newInput.checked;
            currentInput.classList.toggle('disabled', newInput.classList.contains('disabled'));
          }
        });
      }
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // No longer call renderCounts, as we update labels/inputs directly
    // if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
   //console.log('renderActiveFacets')
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
   //console.log('renderAdditionalElements')
    const mobileElementSelectors = ['.facets-drawer__open', '.facets-drawer__count', '.sorting', '.facets-drawer__total-active'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //Re:Bind menu-drawer
    document.getElementById('FacetFiltersFormDrawer').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    //console.log('renderCounts')
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
   //console.log('onSubmitHandler')
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'facets-drawer__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormDrawer';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormDrawer') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
   //console.log('onActiveFilterClick')
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
